/******************************************************************************************
 *	Include Directive
 *******************************************************************************************
 *
 * Similar to ngInclude with 2 key diferences:
 * - No isolated scope, so included template works as if it was placed in-line
 * - Replaces host element with template contents
 *
 */
(function() {
  

  angular.module('rcDirectives.include', []).directive(
    'rcInclude',
    /* @ngInject */
    function($http, $templateCache, $compile) {
      return {
        restrict: 'AE',
        priority: 400, //Matches ngInclude priority
        terminal: true,
        link: function(scope, element, attrs) {
          var src = attrs.rcInclude;
          if (src) {
            $http.get(src, {cache: $templateCache}).then(function(response) {
              var template = $compile(response.data)(scope);
              element.replaceWith(template);
            });
          }
        }
      };
    }
  );
})();
